import { createAsyncAction } from 'redux-promise-middleware-actions';
import { addAsyncActionPostfixes } from '../utils/actionTypeCreator';
import api from '../api/apiSettings';

export const types = {
  ...addAsyncActionPostfixes({
    FETCH_JOB: 'FETCH_JOB',
    FETCH_PUBLIC_JOB: 'FETCH_PUBLIC_JOB',
    SAVE_CURRENT_JOB: 'SAVE_CURRENT_JOB',
    UNSAVE_CURRENT_JOB: 'UNSAVE_CURRENT_JOB'
  })
};

export const fetchJob = createAsyncAction(types.FETCH_JOB, (referenceId) =>
  api.get(`v1/job/${referenceId}`).then((res) => res.data)
);

export const fetchPublicJob = createAsyncAction(types.FETCH_PUBLIC_JOB, (referenceId) =>
  api.get(`v1/job/public-job/${referenceId}`).then((res) => res.data)
);

export const saveCurrentJob = createAsyncAction(types.SAVE_CURRENT_JOB, (id, userId) =>
  api.post(`v1/job/save-job`, { JobId: id, UserId: userId }).then((res) => ({ ...res.data }))
);

export const unsaveCurrentJob = createAsyncAction(types.UNSAVE_CURRENT_JOB, (id) =>
  api.delete(`v1/job/remove-saved-job?jobId=${id}`).then((res) => ({ ...res.data }))
);
